import React from "react";
import { Grid } from "@tiny/components";
import { useRefresh } from "@tiny/components/src/RefreshProvider";
import SegmentList from "../../components/SegmentList/SegmentList";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import useCustomSegmentFeatures from "../../hooks/useCustomSegmentFeatures";
import SegmentsStatistics from "./SegmentsStatistics/SegmentsStatistics";

function CustomSegments() {
  const { mdUp, lgUp } = useBreakpoints();

  const { hasRightsToAccess } = useCustomSegmentFeatures();

  const { refresh } = useRefresh();

  if (!hasRightsToAccess()) {
    return null;
  }

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 3}>
      <Grid item xs={12}>
        <SegmentsStatistics />
      </Grid>
      <Grid item xs={12}>
        <SegmentList
          pageName="customSegments"
          onCloneSuccess={refresh}
          onDeleteSuccess={refresh}
        />
      </Grid>
    </Grid>
  );
}

export default CustomSegments;
